/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlistDetails } from './FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlistDetails';
import {
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlistDetailsFromJSON,
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlistDetailsFromJSONTyped,
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlistDetailsToJSON,
} from './FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlistDetails';

/**
 * 
 * @export
 * @interface UpdateLeadWaitlistStatusRequest
 */
export interface UpdateLeadWaitlistStatusRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateLeadWaitlistStatusRequest
     */
    status?: UpdateLeadWaitlistStatusRequestStatusEnum;
    /**
     * 
     * @type {FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlistDetails}
     * @memberof UpdateLeadWaitlistStatusRequest
     */
    details?: FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlistDetails;
}


/**
 * @export
 */
export const UpdateLeadWaitlistStatusRequestStatusEnum = {
    Waitlisted: 'Waitlisted',
    Cleared: 'Cleared',
    Cancelled: 'Cancelled'
} as const;
export type UpdateLeadWaitlistStatusRequestStatusEnum = typeof UpdateLeadWaitlistStatusRequestStatusEnum[keyof typeof UpdateLeadWaitlistStatusRequestStatusEnum];


/**
 * Check if a given object implements the UpdateLeadWaitlistStatusRequest interface.
 */
export function instanceOfUpdateLeadWaitlistStatusRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function UpdateLeadWaitlistStatusRequestFromJSON(json: any): UpdateLeadWaitlistStatusRequest {
    return UpdateLeadWaitlistStatusRequestFromJSONTyped(json, false);
}

export function UpdateLeadWaitlistStatusRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateLeadWaitlistStatusRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': !exists(json, 'status') ? undefined : json['status'],
        'details': !exists(json, 'details') ? undefined : FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlistDetailsFromJSON(json['details']),
    };
}

export function UpdateLeadWaitlistStatusRequestToJSON(value?: UpdateLeadWaitlistStatusRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'details': FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlistDetailsToJSON(value.details),
    };
}

